module.exports = __webpack_public_path__ + "static/media/linkedin-white.cdf704df.svg";